import React from 'react';
import '../styles/modal.css';

const EmailModal = ({
  isOpen,
  onClose,
  onContinue,
  email,
  setEmail,
  rememberMe,
  setRememberMe
}) => {
  if (!isOpen) return null;

  const handleContinue = () => {
    if (email) {
      onContinue();
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <p className="modal-subtitle">Get Updates via Email</p>

        <input
          type="email"
          className="modal-input"
          placeholder="Enter your email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoFocus
        />

        <label className="remember-me">
          <input
            type="checkbox"
            checked={rememberMe}
            onChange={(e) => setRememberMe(e.target.checked)}
          />
          <span>Remember me</span>
        </label>

        <button
          className="continue-button"
          onClick={handleContinue}
          disabled={!email}
        >
          Continue
        </button>

        <button className="maybe-later" onClick={onClose}>
          Maybe Later
        </button>

        <p className="spam-note">No spam. Unsubscribe anytime</p>
      </div>
    </div>
  );
};

export default EmailModal;